/**
 * Canonical field-type → operator authority shared by browser and API.
 * Descriptors may narrow this list with allowedFilterOperators, never widen it.
 */
export function getDefaultFilterOperatorsForType(fieldType = 'text') {
    switch (fieldType) {
        case 'text':
            return ['contains', 'equals', 'notEquals', 'startsWith', 'endsWith', 'isNull', 'isNotNull'];
        case 'number':
        case 'decimal':
        case 'quantity':
        case 'money':
        case 'percentage':
            return ['equals', 'notEquals', 'gt', 'gte', 'lt', 'lte', 'between', 'isNull', 'isNotNull'];
        case 'date':
        case 'datetime':
            return ['on', 'before', 'after', 'between', 'equals', 'notEquals', 'isNull', 'isNotNull'];
        case 'select':
        case 'status':
        case 'reference':
            return ['equals', 'notEquals', 'in', 'notIn', 'isNull', 'isNotNull'];
        case 'boolean':
            return ['equals', 'notEquals', 'isNull', 'isNotNull'];
        case 'link':
            return ['isNull', 'isNotNull'];
        default:
            return ['equals'];
    }
}
export function getAllowedFilterOperators(column) {
    const defaults = getDefaultFilterOperatorsForType(column.fieldType ?? 'text');
    if (!column.allowedFilterOperators?.length)
        return defaults;
    const allowed = new Set(defaults);
    return column.allowedFilterOperators.filter(operator => allowed.has(operator));
}
